import { render, staticRenderFns } from "./ModalAppointment.vue?vue&type=template&id=2310e509&scoped=true&lang=pug"
import script from "./ModalAppointment.vue?vue&type=script&lang=js"
export * from "./ModalAppointment.vue?vue&type=script&lang=js"
import style0 from "./ModalAppointment.vue?vue&type=style&index=0&id=2310e509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2310e509",
  null
  
)

export default component.exports